import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-404',
    templateUrl: './404.component.html',
    styleUrls: ['./404.component.scss'],
    imports: [RouterModule]
})
export class E404Component {

  constructor() { }
}
